import { all, call, put, takeEvery } from 'redux-saga/effects'
import {
  getSubleases,
  getSublease,
  addApplicationDecision,
  deleteApplicationDecision,
  changeSubleaseEndDate,
  getTenantsHistoryInUnit,
  getSubleaseSettings,
} from '../../api/sublease.api'
import axios from 'axios'
import {
  addSubleaseDecisionFailed,
  addSubleaseDecisionRequested,
  addSubleaseDecisionSuccess,
  fetchSubleaseList,
  fetchSubleaseListFailed,
  fetchSubleaseListSuccess,
  fetchSubleaseSettingsFailed,
  fetchSubleaseSettingsRequested,
  fetchSubleaseSettingsSuccess,
  subleaseDetailsFailed,
  subleaseDetailsRequested,
  subleaseDetailsSuccess,
  subleaseHistoricalTenantsFailed,
  subleaseHistoricalTenantsRequested,
  subleaseHistoricalTenantsSuccess,
  undoSubleaseDecisionFailed,
  undoSubleaseDecisionRequested,
  undoSubleaseDecisionSuccess,
  updateEndDateFailed,
  updateEndDateRequested,
  updateEndDateSuccess,
} from '.'
import { PayloadAction } from '@reduxjs/toolkit'

function* fetchSubleases(action: PayloadAction<any>): any {
  try {
    const response = yield call(
      getSubleases,
      action.payload.clientId,
      action.payload.filters,
      action.payload.source
    )

    yield put(fetchSubleaseListSuccess(response.data))
  } catch (e) {
    if (!axios.isCancel(e)) {
      yield put(fetchSubleaseListFailed(e))
    }
  }
}

function* fetchSublease(action: PayloadAction<any>): any {
  try {
    const response = yield call(getSublease, action.payload)
    yield all([
      yield put(subleaseHistoricalTenantsRequested(response.data.propertyId)),
      yield put(subleaseDetailsSuccess(response.data)),
    ])
  } catch (e) {
    if (!axios.isCancel(e)) {
      yield put(subleaseDetailsFailed(e))
    }
  }
}

function* fetchHistoricalTenants(action: PayloadAction<any>) {
  try {
    const threeYearsBack = new Date()
    threeYearsBack.setFullYear(new Date().getFullYear() - 3)

    const { data } = yield call(
      getTenantsHistoryInUnit,
      action.payload,
      threeYearsBack
    )
    yield put(subleaseHistoricalTenantsSuccess(data.result))
  } catch (e) {
    if (!axios.isCancel(e)) {
      yield put(subleaseHistoricalTenantsFailed(e))
    }
  }
}

function* addDecision(action: PayloadAction<any>) {
  try {
    yield call(
      addApplicationDecision,
      action.payload.id,
      action.payload.comment,
      action.payload.decision,
      action.payload.lastUpdate
    )

    yield all([
      put(addSubleaseDecisionSuccess()),
      put(subleaseDetailsRequested(action.payload.id)),
    ])
  } catch (e) {
    yield put(addSubleaseDecisionFailed(e))
  }
}

function* undoDecision(action: PayloadAction<any>) {
  try {
    yield call(deleteApplicationDecision, action.payload)

    yield all([
      put(undoSubleaseDecisionSuccess()),
      put(subleaseDetailsRequested(action.payload)),
    ])
  } catch (e: any) {
    // TODO Fix error message
    yield put(undoSubleaseDecisionFailed(e))
  }
}

function* updateEnddate(action: PayloadAction<any>) {
  try {
    yield call(
      changeSubleaseEndDate,
      action.payload.id,
      action.payload.newDate,
      action.payload.comment
    )

    yield all([
      put(updateEndDateSuccess()),
      put(subleaseDetailsRequested(action.payload.id)),
    ])
  } catch (e) {
    yield put(updateEndDateFailed(e))
  }
}

function* fetchSubleaseSettings(action: PayloadAction<any>) {
  try {
    const { data } = yield call(getSubleaseSettings, action.payload)
    yield put(fetchSubleaseSettingsSuccess(data))
  } catch (e) {
    console.error(e)
    yield put(fetchSubleaseSettingsFailed(e))
  }
}

function* subleasesSaga() {
  yield takeEvery(fetchSubleaseList.type, fetchSubleases)
  yield takeEvery(subleaseDetailsRequested.type, fetchSublease)
  yield takeEvery(
    subleaseHistoricalTenantsRequested.type,
    fetchHistoricalTenants
  )

  yield takeEvery(addSubleaseDecisionRequested.type, addDecision)
  yield takeEvery(undoSubleaseDecisionRequested.type, undoDecision)
  yield takeEvery(updateEndDateRequested.type, updateEnddate)
  yield takeEvery(fetchSubleaseSettingsRequested.type, fetchSubleaseSettings)
}

export default subleasesSaga
